﻿/** Deterministic, zero-token concept discovery over already-retrieved excerpts. */
export type ConceptSource = { id: string; title: string; text: string; score?: number }
export type ConceptNeighbour = { term: string; documents: number; evidence: { id: string; title: string; excerpt: string }[] }
const ignored = new Set(['about','after','again','against','also','among','because','before','being','between','could','different','during','each','from','have','into','itself','more','other','their','there','these','those','through','under','which','while','would','your','with','that','this','they','them','then','than','when','where','what','were','been','does','such','some','many','only','upon','into','over','very','will','shall','must','might','should','notes','lesson','session','chapter','introduction'])
export function conceptNeighbourhood(sources: ConceptSource[], query: string, limit = 12): ConceptNeighbour[] {
  const needle = query.trim().toLocaleLowerCase()
  if (needle.length < 2) return []
  const terms = new Map<string, { docs: Set<string>; evidence: ConceptNeighbour['evidence'] }>()
  for (const source of sources) {
    const text = source.text || ''
    const index = text.toLocaleLowerCase().indexOf(needle)
    if (index < 0) continue
    const context = text.slice(Math.max(0, index - 180), Math.min(text.length, index + needle.length + 240))
    const tokens = context.match(/[\p{L}][\p{L}\p{M}'’-]{3,}/gu) || []
    for (const raw of new Set(tokens)) {
      const term = raw.toLocaleLowerCase().replace(/^[’'-]+|[’'-]+$/g, '')
      if (term.length < 4 || ignored.has(term) || term === needle || needle.includes(term)) continue
      const entry = terms.get(term) || { docs: new Set<string>(), evidence: [] }
      entry.docs.add(source.id)
      if (!entry.evidence.some(e => e.id === source.id)) entry.evidence.push({ id: source.id, title: source.title, excerpt: context })
      terms.set(term, entry)
    }
  }
  return [...terms.entries()].map(([term, entry]) => ({ term, documents: entry.docs.size, evidence: entry.evidence.slice(0, 3) }))
    .sort((a, b) => b.documents - a.documents || a.term.localeCompare(b.term)).slice(0, Math.max(1, Math.min(limit, 30)))
}
